import { useMemo } from "react";
import { useOperator } from "@/hooks";
import { useGetVehicleTypesQuery } from "@/redux/apis/config/trip/vehicleType/vehicleTypeApi";

export const useVehicleTypeMigrationCheck = () => {
  const { id: operatorId } = useOperator();
  const { data: vehicleTypesData } = useGetVehicleTypesQuery(
    { page: "1", page_size: "200", operator_id: operatorId ?? "" },
    { skip: !operatorId }
  );

  const migration = useMemo(() => {
    if (!vehicleTypesData) return { needsMigration: false, valid: 0, total: 0, isReady: false };

    const customs = vehicleTypesData.vehicleTypes.filter((vt) => !vt.isDefault);
    const total = customs.length;
    const valid = customs.filter((vt) => !!vt.vehicleCategory).length;
    const needsMigration = total > 0 && valid < total;

    return { needsMigration, valid, total, isReady: true };
  }, [vehicleTypesData]);

  return migration;
};
